<div class="tab-content appraisals-container">
  <!--
    Pending-request modal. Auto-opens when the page detects at least one pending
    manager-access request for the current employee. The Requests tab is also auto-
    selected via applyDefaultTabSelection — the modal is the loud, unmissable signal.
  -->
  <p-dialog
    [(visible)]="showPendingRequestPopup"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="false"
    [style]="{ width: '480px', maxWidth: '92vw' }"
    [header]="'APPRAISAL_PENDING_REQUEST_POPUP_TITLE' | translate">
    <p>{{ 'APPRAISAL_PENDING_REQUEST_POPUP_BODY' | translate }}</p>
    <ng-template pTemplate="footer">
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="dismissPendingRequestPopup()">
        {{ 'APPRAISAL_PENDING_REQUEST_LATER' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-success"
        (click)="reviewPendingRequestsNow()">
        {{ 'APPRAISAL_PENDING_REQUEST_REVIEW_NOW' | translate }}
      </button>
    </ng-template>
  </p-dialog>

  <!-- Page Title -->
  <div class="page-title" id="appraisal-module-title">
    <span translate>EMPLOYEE_DIALOG_MEETINGS</span>
  </div>

  <!-- Tab Navigation -->
  <div class="appraisals-tabs">
    <ul class="nav nav-tabs">
      <!-- Appraisals List Tab -->
      <li
        class="nav-item"
        *ngIf="isTabAccessible('list')"
      >
        <a
          id="appraisal-tab-list"
          [class]="getTabClass('list')"
          (click)="switchTab('list')"
          role="button"
        >
          <i
            class="fa"
            [ngClass]="isManager ? 'fa-users' : 'fa-clipboard'"
            aria-hidden="true"
          ></i>
          <span>{{ (isManager ? 'APPRAISAL_MANAGER_MEETINGS' : 'APPRAISALS_LIST') | translate }}</span>
        </a>
      </li>

      <!-- My meetings tab for managers who are also employees -->
      <li class="nav-item" *ngIf="isTabAccessible('my-meetings')">
        <a
          id="appraisal-tab-my-meetings"
          [class]="getTabClass('my-meetings')"
          (click)="switchTab('my-meetings')"
          role="button"
        >
          <i class="fa fa-user-circle-o" aria-hidden="true"></i>
          <span translate>APPRAISAL_MY_MEETINGS</span>
        </a>
      </li>

      <!-- Assignment Requests Tab -->
      <li class="nav-item" *ngIf="canViewAppraisals && hasPendingRequests">
        <a
          id="appraisal-tab-requests"
          [class]="getTabClass('requests')"
          (click)="switchTab('requests')"
          role="button"
        >
          <i class="fa fa-inbox" aria-hidden="true"></i>
          <span translate>APPRAISAL_REQUESTS</span>
        </a>
      </li>

      <li class="nav-item" *ngIf="canViewTasks">
        <a
          id="appraisal-tab-tasks"
          [class]="getTabClass('tasks')"
          (click)="switchTab('tasks')"
          role="button"
        >
          <i class="fa fa-tasks" aria-hidden="true"></i>
          <span translate>APPRAISAL_TASKS</span>
        </a>
      </li>

      <!-- Templates Tab (Manager only) -->
      <li class="nav-item" *ngIf="canManageTemplates">
        <a
          id="appraisal-tab-templates"
          [class]="getTabClass('templates')"
          (click)="switchTab('templates')"
          role="button"
        >
          <i class="fa fa-file-text-o" aria-hidden="true"></i>
          <span translate>APPRAISAL_TEMPLATES</span>
        </a>
      </li>

      <!-- Appraisal settings tab (Manager only) -->
      <li class="nav-item" *ngIf="canManageTemplates">
        <a
          id="appraisal-tab-settings"
          [class]="getTabClass('settings')"
          (click)="switchTab('settings')"
          role="button"
        >
          <i class="fa fa-cog" aria-hidden="true"></i>
          <span translate>SETTINGS</span>
        </a>
      </li>
    </ul>
  </div>

  <appraisal-workflow-guide
    *ngIf="canViewAppraisals && guideReady"
    [activeTab]="activeTab"
    [isManager]="isManager"
    [canManageTasks]="canManageTasks"
    [canManageTemplates]="canManageTemplates"
    [canViewRequests]="hasPendingRequests"
    [hasAppraisalsForCurrentUser]="hasAppraisalsForCurrentUser"
    [storageRoleKey]="guideStorageRoleKey"
    [canSelectGuideRole]="isManager && canViewAppraisals"
    (tabSelected)="switchTab($event)"
  >
  </appraisal-workflow-guide>

  <!-- Tab Content -->
  <div class="tab-pane-content">
    <!-- Appraisals List -->
    <div
      *ngIf="
        isTabActive('list') &&
        canViewAppraisals &&
        (isManager || hasAppraisalsForCurrentUser)
      "
      class="tab-pane active"
    >
      <appraisals-list
        [isManager]="canManageTemplates"
        [viewScope]="(initialViewScope || (isManager ? 'manager' : 'employee'))"
        [initialStatusFilter]="initialStatusFilter"
      ></appraisals-list>
    </div>

    <!-- My meetings employee view -->
    <div
      *ngIf="isTabActive('my-meetings') && isTabAccessible('my-meetings')"
      class="tab-pane active"
    >
      <appraisals-list
        [isManager]="false"
        viewScope="employee"
        [initialStatusFilter]="initialStatusFilter"
      ></appraisals-list>
    </div>

    <!-- Assignment Requests -->
    <div
      *ngIf="isTabActive('requests') && canViewAppraisals && hasPendingRequests"
      class="tab-pane active"
    >
      <appraisals-requests
        (requestsUpdated)="onRequestsUpdated($event)"
      ></appraisals-requests>
    </div>

    <!-- Tasks List -->
    <div *ngIf="isTabActive('tasks') && canViewTasks" class="tab-pane active">
      <appraisals-tasks [isManager]="canManageTasks" [canManageTasks]="canManageTasks"></appraisals-tasks>
    </div>

    <!-- Templates List -->
    <div
      *ngIf="isTabActive('templates') && canManageTemplates"
      class="tab-pane active"
    >
      <appraisals-templates></appraisals-templates>
    </div>

    <!-- Appraisal Settings -->
    <div
      *ngIf="isTabActive('settings') && canManageTemplates"
      class="tab-pane active"
    >
      <appraisals-settings></appraisals-settings>
    </div>

    <!-- No Access Message -->
    <div
      *ngIf="!canViewAppraisals && !canManageTasks && !canManageTemplates"
      class="no-access-message"
    >
      <div class="alert alert-warning">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        <span translate>NO_APPRAISAL_ACCESS</span>
      </div>
    </div>
  </div>
</div>
